<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            NICOMEDES SANTA CRUZ: <br>
            <span style="line-height: 100%;" class="fontMS300">
                VOZ Y MEMORIA DEL PERÚ AFRODESCENDIENTE <br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio41/nicomedes-santacruz">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio41/nicomedes-santacruz">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio41/nicomedes-santacruz">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio41/NICOMEDES_000.png">
</section>

<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
            <br><br>
                <div class="row p-3" style="width: 100%; background-color: #812485; color: white; display: flex; flex-wrap: wrap;">
                    <!-- Columna de texto -->
                    <div style="flex: 1 1 60%; padding: 20px; line-height: 2; text-align: left;">
                        <p class="fontMS300 font-20">
                            <br>
                            NICOMEDES SANTA CRUZ GAMARRA (LIMA, 1925 – MADRID, 1992) FUE UN DESTACADO INTELECTUAL AFROPERUANO, 
                            RECONOCIDO POR SU LABOR COMO POETA, DECIMISTA, FOLCLORISTA Y PENSADOR. SU VIDA Y OBRA ESTUVIERON 
                            PROFUNDAMENTE COMPROMETIDAS CON LA REIVINDICACIÓN DE LA CULTURA AFROPERUANA Y LA DEFENSA DE LOS 
                            DERECHOS DE SU COMUNIDAD.
                        </p>
                    </div>
                    <!-- Columna de imagen -->
                    <div class="img-column" style="flex: 1 1 40%; padding: 20px; text-align: center; ">
                        <a href="http://hdl.handle.net/20.500.14428/82708" target="_blank" >
                            <img style="width:80%; height: auto; object-fit: cover;" src="/assets/images/micrositio/micrositio41/NICOMEDES_001.png" alt="Retrato Nicomedes Santa Cruz">
                        </a>
                        <br><br>
                        <p class="font-12 fontMS300Italic" style="color: white;">
                            Retrato de Nicomedes Santa Cruz. <br>
                            Disponible en: 
                            <a href="http://hdl.handle.net/20.500.14428/82708" target="_blank" style="color: #ffffff;">
                                Biblioteca Digital
                            </a>
                        </p>
                    </div>

                </div>

                <p class="fontMS300 font-24 text-justify">
                    <br><br>
                    NACIDO EN EL DISTRITO LIMEÑO DE LA VICTORIA, EN UN BARRIO OBRERO Y POPULAR, LOS PRIMEROS AÑOS DE SU 
                    VIDA REFLEJARON LA PRECARIEDAD QUE COMPARTÍAN MUCHAS FAMILIAS EN ZONAS URBANAS MARCADAS POR LA 
                    DIVERSIDAD ÉTNICA Y LA EXCLUSIÓN SOCIAL. <br><br>
                    SE FORMÓ EN EL SENO DE UNA FAMILIA PROFUNDAMENTE ARTÍSTICA, HEREDERO DE UNA LARGA TRADICIÓN DE 
                    CULTORES DEL ARTE. SU ABUELO PATERNO, SU PADRE —EL DRAMATURGO NICOMEDES SANTA CRUZ APARICIO— Y SU 
                    HERMANA, LA DESTACADA ARTISTA Y ESTUDIOSA DEL FOLCLORE VICTORIA SANTA CRUZ GAMARRA, MARCARON SU 
                    ENTORNO DESDE TEMPRANA EDAD. AUTODIDACTA POR ELECCIÓN Y NECESIDAD, SU TALENTO PARA LA COMPOSICIÓN 
                    SE CONVIRTIÓ EN UNA DE SUS MAYORES VIRTUDES.
                    <br><br>
                    <br>
                </p>

                <div class="row" style="display: flex; gap: 0;">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <div style="display: flex; width: 95%; ">
                            <div style="flex: 1; display: flex; justify-content: right; align-items: center;">
                                <a href="http://hdl.handle.net/20.500.14428/82707" target="_blank" style="color: #ffffff;">
                                    <img  style="width:100%; height: auto; object-fit: cover;" src="/assets/images/micrositio/micrositio41/NICOMEDES_002.png">
                                </a>
                            </div>
                            <div style="flex: 1; background-color: #424342; display: flex; justify-content: center; align-items: center; color: white; text-align: center;">
                                <p class="font-14 fontMS300Italic">Retrato de Nicomedes Santa Cruz. <br>
                                    Disponible en: <a href="http://hdl.handle.net/20.500.14428/82707" target="_blank" style="color: #ffffff;">Biblioteca Digital</a></p>
                            </div>
                        </div>

                    </div>
                    <div class="col-sm-1"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_001.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100Italic font-24">
                            <br>
                            <span class="text-justify ">
                                <br><br>
                                «CON NICOMEDES SANTA CRUZ NOS ENCONTRAMOS ANTE UN PERSONAJE FUERA DE SERIE, 
                                PUES EN REALIDAD COMO SE HA PLANTEADO REÚNE EN SÍ, UN CONJUNTO DE CUALIDADES 
                                QUE SOLO, EXCEPCIONALMENTE, SE HABÍAN MANIFESTADO Y DESARROLLADO EN FIGURAS 
                                COMO NICOLÁS GUILLÉN Y AIMÉ CÉSAIRE, EN LA POESÍA; LOUIS ARMSTRONG, EN LA MÚSICA; 
                                FERNANDO ORTIZ Y ALEJO CARPENTIER EN LA INVESTIGACIÓN. TODAS ESTAS CUALIDADES 
                                REUNIDAS EN UN AUTODIDACTA, PERIODISTA, COMUNICÓLOGO, Y VIAJERO INCANSABLE, QUE 
                                RECORRIÓ CASI TODA AMÉRICA LATINA, BUENA PARTE DEL CARIBE, ÁFRICA, ASIA Y EUROPA, 
                                DONDE VIVIÓ SUS ÚLTIMOS DIEZ AÑOS». 
                                <br><br>
                                <span class="fontMS100Italic">
                                    ("NICOMEDES SANTA CRUZ: DECIMISTA, POETA Y FOLKLORISTA AFROPERUANO". PABLO A. MARÍÑEZ, 2000).
                                </span>
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_002.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            NICOMEDES SANTA CRUZ:<br>
                            PATRIMONIO CULTURAL<br>
                            DE LA NACIÓN
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    EN EL AÑO 2023, MEDIANTE LA RESOLUCIÓN VICEMINISTERIAL N.° 0161-2023-VMPCIC/MC, SE 
                    DECLARÓ PATRIMONIO CULTURAL DE LA NACIÓN A SEIS UNIDADES BIBLIOGRÁFICAS (1959-1982) 
                    CORRESPONDIENTES A LAS PRIMERAS EDICIONES DE LA OBRA INTELECTUAL DE NICOMEDES 
                    SANTA CRUZ GAMARRA, RESGUARDADAS EN LA BIBLIOTECA NACIONAL DEL PERÚ. DE ESTA 
                    FORMA, SE RECONOCIÓ SU NOTABLE VALOR, SIGNIFICADO E IMPORTANCIA PARA EL PROCESO 
                    HISTÓRICO Y CULTURAL DEL PAÍS.
                    <br>
                </p>
                <div class="row p-5">
                    <div class="col-sm-12">
                        <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_042.png">
                        <p class="fontMS300Italic text-center text-gris"><br>
                            Obras de Nicomedes Santa Cruz declaradas Patrimonio<br>
                            Cultural de la Nación en 2023
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            NEGRO SOY: EL PENSAMIENTO<br>
                            DE NICOMEDES SOBRE<br>
                            IDENTIDAD Y CULTURA<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    DESDE SUS PRIMEROS ACERCAMIENTOS AL ESCENARIO PÚBLICO, NICOMEDES SANTA CRUZ 
                    MANTUVO EL COMPROMISO DE REIVINDICAR LA CULTURA AFROPERUANA, DESMONTANDO LOS 
                    ESTEREOTIPOS NEGATIVOS ASOCIADOS A LO NEGRO EN EL PERÚ. Y NO SOLO BUSCÓ 
                    POSICIONARSE COMO UN AUTOR VINCULADO A LA CUESTIÓN AFROPERUANA, SINO SER UN 
                    REPRESENTANTE ACTIVO DE ESTE RESCATE CULTURAL, ADOPTANDO UNA POSTURA PÚBLICA DE 
                    REIVINDICACIÓN Y DENUNCIA FRENTE A LA HERENCIA COLONIAL QUE CIMENTÓ LA 
                    DISCRIMINACIÓN RACIAL EN EL PAÍS.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82706" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_004.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Retrato de Nicomedes Santa Cruz.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82706" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82709" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_005.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Nicomedes y Victoria Santa Cruz en 
                            presentación de obra «Malató». 1961.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82709" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82710" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_006.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Nicomedes Santa Cruz y el actor Luis Álvarez. 
                            Década del sesenta.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82710" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="text-justify text-white fontMS100 font-24">
                    <br><br>
                    A MENUDO RELEGADO EN LAS MENCIONES A LOS PRINCIPALES INTELECTUALES PERUANOS DEL SIGLO XX, NICOMEDES 
                    SANTA CRUZ MERECE SER UBICADO EN UNA CATEGORÍA PARTICULAR: LA DE AQUEL QUE, DESDE LA PLENA CONCIENCIA 
                    DE SU IDENTIDAD AFRODESCENDIENTE, SE RECONOCE COMO SUJETO HISTÓRICO, CAPAZ DE INTERPRETAR 
                    CRÍTICAMENTE LAS CONDICIONES QUE LO LIMITAN Y, AL MISMO TIEMPO, DE IMAGINAR Y LUCHAR POR POSIBILIDADES 
                    CONCRETAS DE TRANSFORMACIÓN.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82755" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_007.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Racismo en el Perú / Nicomedes Santa Cruz. Expreso. 
                            Supl. Estampa (1 de octubre de 1967).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82755" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82760" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_008.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            ¿Son inmorales los negros? / Nicomedes Santa Cruz. 
                            Expreso. Supl. Estampa (22 de octubre de 1967).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82760" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82742" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_009.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Las orgías negras de Zaña / Nicomedes Santa Cruz. 
                            Expreso. Supl. Estampa (10 de diciembre de 1967).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82742" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <p class="text-justify text-white fontMS100 font-24">
                    <br><br>
                    COMO HA SEÑALADO EL HISTORIADOR CARLOS AGUIRRE (2013), SANTA CRUZ PUEDE SER COMPRENDIDO DENTRO DE 
                    LA NOCIÓN DE “INTELECTUAL POPULAR”: SU OBRA, CON UN PROFUNDO IMPACTO SOCIAL Y CULTURAL, LOGRÓ UNA 
                    RESONANCIA QUE INCLUSO SUPERÓ A LA DE MUCHOS INTELECTUALES ACADÉMICOS. SU LEGADO Y SU ACTIVA 
                    REIVINDICACIÓN DE LA CULTURA AFROPERUANA LO CONSOLIDARON COMO UNA FIGURA CENTRAL PARA EL ESTUDIO 
                    DE LA AFRODESCENDENCIA EN EL PERÚ.
                    <br>
                </p>

            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            NEGRO SOY: NICOMEDES Y LA<br>
                            CONSTRUCCIÓN DE UNA<br>
                            IDENTIDAD AFROPERUANA<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    PARA PABLO A. MARÍÑEZ (2000), AMIGO Y ESTUDIOSO DE LA OBRA DE NICOMEDES SANTA CRUZ, 
                    LA REFLEXIÓN SOBRE LO NEGRO EN EL MUNDO Y SUS APORTES CULTURALES FUE UN PUNTO DE 
                    PARTIDA FUNDAMENTAL EN LA FORMACIÓN DEL PENSAMIENTO DEL POETA. ESTA PERSPECTIVA 
                    SE VIO ENRIQUECIDA POR SUS VIAJES A DIVERSOS PAÍSES DE AMÉRICA LATINA Y, MÁS ADELANTE, 
                    A ÁFRICA, ASÍ COMO POR EL VÍNCULO QUE ESTABLECIÓ CON DESTACADOS INTELECTUALES DE 
                    SU TIEMPO, TANTO EN EL PERÚ COMO EN NACIONES CON UNA FUERTE HERENCIA AFRICANA, 
                    COMO BRASIL Y CUBA.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82711" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_010.png">
                        </a>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes Santa Cruz y el escritor peruano Sebastián Salazar 
                            Bondy. 1962.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82711" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row">
                    <br>
                    <hr style="height: 2px; background-color: black; border: none;" class="w-100" >
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes y hermanos Ascuez. Década del sesenta.  <br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82712" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82712" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_011.png">
                        </a>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row">
                    <br>
                    <hr style="height: 2px; background-color: black; border: none;" class="w-100" >
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82713" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_012.png">
                        </a>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes Santa Cruz y Juan Mejía Baca en el programa «Esta es 
                            su vida», conducido por Pablo de Madalengoitia. 1961.   <br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82713" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>

                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <p class="text-justify  fontMS300 font-24 p-5">
                    <br><br>
                    SU YA MENCIONADA CONDICIÓN DE “FIGURA PÚBLICA” LE PERMITIÓ COMPARTIR ESCENARIOS Y 
                    ESPACIOS DE DISCUSIÓN CON DIVERSOS PERSONAJES QUE INFLUYERON EN ÉL O GENERARON 
                    DEBATE. SIN EMBARGO, ES IMPORTANTE DESTACAR QUE MUCHOS DE SUS PLANTEAMIENTOS EN 
                    TORNO A LA CUESTIÓN DE LO NEGRO COMENZARON A GESTARSE DESDE SU JUVENTUD, EN EL 
                    SENO DE SU ENTORNO FAMILIAR.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes Santa Cruz y el músico cubano Elio Revé sobre el 
                            escenario en el CICLA. Lima, 1987.  <br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82718" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82718" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_013.png">
                        </a>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row">
                    <br>
                    <hr style="height: 2px; background-color: black; border: none;" class="w-100" >
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82715" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_014.png">
                        </a>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes Santa Cruz al lado del poeta español Marcos Ana y su 
                            esposa Mercedes Castillo. Años ochenta.  <br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82715" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>

                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row">
                    <br>
                    <hr style="height: 2px; background-color: black; border: none;" class="w-100" >
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <p class="fontMS100Italic text-center font-12 p-5" >
                            <br><br>
                            Nicomedes Santa Cruz en Japón. 1976.  <br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82716" target="_blank" style="color: #000000;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82716" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_015.png">
                        </a>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <p class="text-justify  fontMS300 font-24 p-5">
                    <br><br>
                    EN SUS PRIMEROS AÑOS DE PRODUCCIÓN INTELECTUAL Y ARTÍSTICA, LOS POEMAS DE NICOMEDES 
                    SANTA CRUZ REVELAN LA PRESENCIA DE UN SUJETO QUE SE ASUME COMO NEGRO Y LO EXPRESA 
                    ABIERTAMENTE EN EL ESPACIO PÚBLICO. CON EL TIEMPO, SU OBRA SE NUTRIRÍA DE NUEVOS 
                    ELEMENTOS E INFLUENCIAS, COMO LOS PROCESOS DE DESCOLONIZACIÓN EN ÁFRICA, LA 
                    REVOLUCIÓN CUBANA Y LA REVOLUCIÓN VELASQUISTA EN EL PERÚ.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82737" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_016.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            «… Al undero le da ¡Saña!» / por Nicomedes Santa Cruz. Expreso. Supl. Estampa 
                            (1 de diciembre de 1963).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82737" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <a href="http://hdl.handle.net/20.500.14428/82756" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_017.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Ritmos negros del Perú / por Nicomedes Santa Cruz. Expreso. Supl. Estampa (9 
                            de febrero de 1964).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82756" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            VOCES Y SONIDOS<br>
                            AFROPERUANOS:<br>
                            EL LEGADO MUSICAL DE<br>
                            NICOMEDES SANTA CRUZ<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>

                <div class="row p-5">
                    <div class="col-sm-12">
                        <p class="text-justify text-white fontMS300 font-24">
                            <br><br>
                            LA DISCOGRAFÍA DE NICOMEDES SANTA CRUZ ES UN TESTIMONIO SONORO FUNDAMENTAL DE LA 
                            CULTURA AFROPERUANA. A TRAVÉS DE DÉCIMAS, POEMAS Y RITMOS TRADICIONALES, COMO EL 
                            FESTEJO, EL LANDÓ Y LA ZAMACUECA, RESCATÓ Y DIFUNDIÓ CON FUERZA LA HERENCIA AFRICANA 
                            EN EL PERÚ. SUS GRABACIONES, REALIZADAS EN LA SEGUNDA MITAD DEL SIGLO XX, ENTRELAZAN 
                            ARTE ORAL, IDENTIDAD CULTURAL Y COMPROMISO SOCIAL, DEJANDO UN LEGADO MUSICAL QUE 
                            SIGUE RESONANDO E INSPIRANDO A NUEVAS GENERACIONES.
                            <br>
                        </p>
                    </div>
                </div>
                <div class="row p-5">
                    <div class="col-sm-12" style="position: relative;" >
                        <div style="position: relative; overflow: hidden; height: 600px;">
                            <a class="video" href="https://youtube.com/embed/OWwISi-CVQU" target="_blank" style="color: black;">
                                <img class="zoomed-img" src="https://i.ytimg.com/vi/OWwISi-CVQU/sddefault.jpg" alt="Imagen recortada"/>
                            </a>
                        </div>
                        <p class="fontMS100Italic font-12 text-white text-center" style="word-wrap: break-word;">
                            <br>
                            "El Canto del Pueblo". Nicomedes Santa Cruz (guitarra de César Isella). México 1982. <br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=OWwISi-CVQU" target="_blank" style="color: #ffffff;">https://www.youtube.com/watch?v=OWwISi-CVQU</a>    
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6" style="position: relative;">
                        <div style="position: relative; overflow: hidden; height: 285px;">
                            <a class="video" href="https://youtube.com/embed/wOSwUXPspCw" target="_blank" style="color: black;">
                                <img class="zoomed-img"   src="https://img.youtube.com/vi/wOSwUXPspCw/hqdefault.jpg" alt="Imagen recortada"/>
                            </a>
                        </div>

                        <p class="fontMS100Italic font-12 text-white text-center" style="word-wrap: break-word;">
                            <br>
                            III Festival Latinoameriano de folclore de Salta. 1967. Nicomedes Santa Cruz y su Conjunto Cumanana.<br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=wOSwUXPspCw" target="_blank" style="color: #ffffff;">https://www.youtube.com/watch?v=wOSwUXPspCw</a> 
                        </p>
                    </div>
                    <div class="col-sm-6" style="position: relative;">
                        <div style="position: relative; overflow: hidden; height: 285px;">
                            <a class="video" href="https://youtube.com/embed/q_-OmhLRCAs" target="_blank" style="color: black;">
                                <img class="zoomed-img"   src="https://img.youtube.com/vi/q_-OmhLRCAs/hqdefault.jpg" />
                            </a>
                        </div>

                        <p class="fontMS100Italic font-12 text-white text-center" style="word-wrap: break-word;">
                            <br>
                            Canción de cuna para despertar a un negrito' de Nicolás Guillén. Voz: Nicomedes Santa Cruz. <br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=q_-OmhLRCAs" target="_blank" style="color: #ffffff;">https://www.youtube.com/watch?v=q_-OmhLRCAs</a> 
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">

                <p class="text-justify  fontMS300 font-24">
                    <br><br>
                    SU APORTE CONSTITUYE UN VALIOSO REGISTRO DE LA HISTORIA ORAL DEL PUEBLO AFROPERUANO. A 
                    TRAVÉS DE LA DÉCIMA, NO SOLO COMO FORMA POÉTICA SINO TAMBIÉN COMO HERRAMIENTA 
                    POLÍTICA, LLEVÓ A LOS ESCENARIOS Y ESTUDIOS DE GRABACIÓN UN ARTE QUE ANTES EXISTÍA 
                    ÚNICAMENTE EN ESPACIOS MARGINADOS.
                    <br>
                    SUS COMPOSICIONES MUSICALES, PRODUCIDAS A LO LARGO DE LOS AÑOS, SIGUEN VIGENTES EN LA 
                    MEMORIA COLECTIVA DEL PERÚ POR LA ACTUALIDAD Y URGENCIA DE LOS TEMAS QUE ABORDAN, CON 
                    UNA CLARA INTENCIÓN DE IMPULSAR A LA POBLACIÓN AFROPERUANA A ASUMIRSE POSITIVAMENTE 
                    COMO PRUEBA MAYOR DE REIVINDICACIÓN.
                </p>

                <div class="row p-5">
                    <div class="col-sm-12" style="position: relative;" >
                        <div style="position: relative; overflow: hidden; height: 530px;">
                            <a class="video" href="https://youtube.com/embed/X6EymTsnOEk" target="_blank" style="color: black;">
                                <img class="zoomed-img" src="/assets/images/micrositio/micrositio41/NICOMEDES_018.png" alt="Imagen recortada"/>
                            </a>
                        </div>
                        <p class="fontMS100Italic font-12 text-center" style="word-wrap: break-word;">
                            <br>
                            Décima a El Señor de los Milagros. Nicomedes Santa Cruz.<br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=X6EymTsnOEk" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=X6EymTsnOEk</a>    
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_001.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100Italic font-24">
                            <br>
                            <span class="text-center">
                                <br><br>
                                «A VARIAS DÉCADAS DE DISTANCIA, Y SIGNIFICATIVAMENTE EN EL HOMENAJE A NICOMEDES, QUIERO 
                                AVENTURAR UN PUNTO DE VISTA MUY PERSONAL: QUISIERA CREER TAN SOLO QUE —PESE A TODO— EL QUE 
                                LOS NEGROS DEL PERÚ SE EXPRESEN NUEVAMENTE A TRAVÉS DE LA DANZA ES HOY ES UNA REALIDAD. EL 
                                QUE UNA GRAN MAYORÍA DE NEGROS Y MESTIZOS DE NEGRO TENGA OTRA VEZ ZAMACUECAS Y LANDÓ ES 
                                UNA REALIDAD. Y EL LADO POSITIVO DE ESTA REALIDAD SE LO DEBEMOS A VICTORIA Y A NICOMEDES».
                                <br><br>
                                
                                    ("MI TÍO NICOMEDES". OCTAVIO SANTA CRUZ, 2015)
                                
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_002.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            CULTURA Y VIDA:<br>
                            APORTES DE NICOMEDES<br>
                            SANTA CRUZ AL ESTUDIO<br>
                            DEL FOLCLOR PERUANO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    NICOMEDES SANTA CRUZ REALIZÓ VALIOSAS INVESTIGACIONES QUE ABARCARON EL ESTUDIO DE 
                    LA GLOSA Y LA DÉCIMA; EL FOLCLOR MUSICAL Y DANZARIO; LA PRESENCIA DEL PUEBLO 
                    AFRODESCENDIENTE EN EL PERÚ Y EN AMÉRICA LATINA; Y SUS APORTES MUSICALES EN AMBOS 
                    CONTEXTOS.
                    <br>
                </p>

                <div class="row p-5">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/82714" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_019.png">
                        </a>
                        <p class="fontMS300Italic text-center text-gris"><br>
                            Nicomedes Santa Cruz en estudio de Canal 4. 1961.<br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82714" target="_blank" style="color: #000000;">Biblioteca Digital</a>  
                        </p>
                    </div>
                </div>

                <p class="text-center fontMS300 font-24">
                    <br><br>
                    LA LABOR DE NICOMEDES SANTA CRUZ EN EL ESTUDIO DE LA CULTURA Y EL FOLCLORE MUSICAL, 
                    ESPECIALMENTE EN RITMOS COMO LA MARINERA Y EL TONDERO, FUE FUNDAMENTAL PARA 
                    ESCLARECER ASPECTOS COMO LOS ORÍGENES, LA COREOGRAFÍA Y LA ESTRUCTURA RÍTMICA DE 
                    ESTAS EXPRESIONES. SU INVESTIGACIÓN TAMBIÉN PERMITIÓ RASTREAR CON RIGOR LA RAÍZ 
                    AFRICANA DE ESTAS MANIFESTACIONES, DEMOSTRANDO QUE ESTE PUEBLO LLEGÓ AL PERÚ CON 
                    SUS PROPIOS VALORES CULTURALES Y UNA PROFUNDA APTITUD PARA EL CANTO Y EL BAILE, 
                    EXPRESADA EN TODAS SUS FORMAS Y LENGUAS.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82750" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_020.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Lundu: abuela africana de la marinera / Nicomedes<br>
                            Santa Cruz. Expreso. Supl. Estampa (5 de noviembre<br>
                            de 1967).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82750" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82744" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_021.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El tondero "La glosa"/ por Nicomedes Santa Cruz.<br>
                            Expreso. Supl. Estampa (1 de marzo de 1964) .<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82744" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82743" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_022.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El tondero / por Nicomedes Santa Cruz. Expreso.<br>
                            Supl. Estampa (8 de marzo de 1964).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82743" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82741" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_023.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El tondero "la fuga" / por Nicomedes Santa Cruz.<br>
                            Expreso. Supl. Estampa (15 de julio de 1964).<br>
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82741" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82739" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_024.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El valse criollo / por Nicomedes Santa Cruz. Expreso.<br>
                            Supl. Estampa (22 de marzo de 1964).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82739" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82758" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_025.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Son de los diablos / por Nicomedes Santa Cruz.<br>
                            Expreso. Supl. Estampa (15 de diciembre de 1963).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82758" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
                
                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82747" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_026.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El festejo / por Nicomedes Santa Cruz. Expreso. Supl.<br>
                            Estampa (26 de enero de 1964).<br>
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82747" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82748" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_027.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            El panalivio / por Nicomedes Santa Cruz. Expreso.<br>
                            Supl. Estampa (23 de febrero de 1964).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82748" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82738" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_028.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Así se baila la marinera / por Nicomedes Santa Cruz.<br>
                            Expreso. Supl. Estampa (28 de marzo de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82738" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            HISTORIAS DE MI TIERRA NEGRA:<br>
                            CUENTOS DE NICOMEDES<br>
                            SANTA CRUZ<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div>

                <div class="row p-5">
                    <div class="col-sm-12">
                        <p class="text-justify text-white fontMS300 font-24">
                            <br><br>
                            LOS ESTUDIOSOS DE SU OBRA COINCIDEN EN QUE FUE UNO DE LOS INTELECTUALES MÁS ACTIVOS DE 
                            SU GENERACIÓN, PUBLICANDO LIBROS DE DIVERSOS GÉNEROS, ASÍ COMO ENSAYOS Y CUENTOS BREVES 
                            QUE APARECIERON SISTEMÁTICAMENTE EN DIARIOS Y REVISTAS DURANTE VARIAS DÉCADAS.
                            <br>
                        </p>
                    </div>
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/82717" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_029.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Nicomedes Santa Cruz recibiendo la «Orden al mérito por servicios
                            distinguidos en el Grado de Comendador». Embajada del Perú en
                            España, 19 de julio de 1990.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82717" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col mx-3 md-3">
                        <a href="http://hdl.handle.net/20.500.14428/82719" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_030.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Nicomedes Santa Cruz y el poeta español Rafael Alberti. 1990.<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82719" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="text-center  fontMS300 font-24">
                    <br><br>
                    UN ASPECTO CLAVE DEL APORTE DE NICOMEDES SANTA CRUZ A LA LITERATURA ES QUE NO 
                    SOLO DIFUNDIÓ Y PRESERVÓ GÉNEROS TRADICIONALES COMO LA DÉCIMA, SINO QUE TAMBIÉN 
                    INCORPORÓ EN SUS ENSAYOS Y CUENTOS LA VOZ DE PERSONAJES QUE REFLEJABAN LA 
                    PLURICULTURALIDAD DEL PERÚ. EN LOS RELATOS QUE PUBLICÓ PERIÓDICAMENTE EN DIARIOS 
                    COMO EL COMERCIO Y EXPRESO, SE APRECIA EL USO CONSTANTE DE TRADICIONES 
                    POPULARES, LO QUE EVIDENCIA SU DOMINIO DE UNA TEMÁTICA DIVERSA Y PROFUNDAMENTE 
                    ENRAIZADA EN LA CULTURA POPULAR.
                    <br>
                </p>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82759" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_031.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Un cuento negro / por Nicomedes Santa Cruz. 
                            Expreso. Supl. Estampa (21 de febrero de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82759" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82754" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_032.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Piña / por Nicomedes Santa Cruz. Expreso. Supl. 
                            Estampa (27 de junio de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82754" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82749" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_033.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Los grillos / por Nicomedes Santa Cruz. Expreso. Supl. 
                            Estampa (4 de julio de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82749" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>

                <div class="row  mt-5">
                    <!-- <div class="col-sm-1"></div> -->
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82753" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_034.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Perros y gatos / por Nicomedes Santa Cruz. Expreso. 
                            Supl. Estampa (11 de julio de 1965).<br>
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82753" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82757" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_035.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Siete / por Nicomedes Santa Cruz. Expreso. Supl. 
                            Estampa (18 de julio de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82757" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82745" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_036.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Contrasuelazo / por Nicomedes Santa Cruz. Expreso. 
                            Supl. Estampa (5 de setiembre de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82745" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-1"></div> -->
                </div>
                
                <div class="row  mt-5">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82746" target="_blank" >
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_037.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Machacuy (Machaaway) / por Nicomedes Santa 
                            Cruz. Expreso. Supl. Estampa (3 de octubre de 1965).<br>
                            <br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82746" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <a href="http://hdl.handle.net/20.500.14428/82751" target="_blank" style="color: #ffffff;">
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_038.png">
                        </a>
                        
                        <p class="fontMS100Italic text-center text-white font-12" style="background: #000000; padding-left: 2%; padding-right: 2%;" >
                            <br><br>
                            Ojos de ver / por Nicomedes Santa Cruz. Expreso. 
                            Supl. Estampa (14 de noviembre de 1965).<br><br>
                            Disponible en: <a href="http://hdl.handle.net/20.500.14428/82751" target="_blank" style="color: #ffffff;">Biblioteca Digital</a>               
                            <br><br><br>
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">

                    <!-- <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div> -->
                    <div class="col-sm-12">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-left colorPrincipal font-30">
                            <img src="/assets/images/micrositio/micrositio41/NICOMEDES_ICONO_000.png" alt="Ícono" style="vertical-align: middle; margin-right: 8px;">
                            MEMORIA VIVA: CUMANANAS<br>
                        </p>
                    </div>
                    <!-- <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                    </div> -->
                </div>

                <!-- <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio41/NICOMEDES_LINEA_003.png">
                </div> -->
                <p class="text-justify  fontMS300 font-24 p-5">
                    <br>
                    EN MAYO DE 2025, LA BIBLIOTECA NACIONAL DEL PERÚ REALIZÓ EL REGISTRO DEL PATRIMONIO 
                    ORAL DE LA CUMANANA EN LA LOCALIDAD DE YAPATERA (PIURA), EN LA VOZ DE ANTIO 
                    ABELARDO ALZAMORA ARÉVALO, PRESIDENTE DE LA CASA DE LA CULTURA YAPATERA. ESTA 
                    MANIFESTACIÓN ARTÍSTICA, QUE ENTRELAZA LA POESÍA POPULAR, LA MÚSICA TRADICIONAL Y LA 
                    HERENCIA AFROPERUANA, REPRESENTA UNA DE LAS EXPRESIONES MÁS VIBRANTES Y 
                    SINGULARES DE LA CULTURA ORAL DEL NORTE DEL PERÚ.
                    
                </p>

                <div class="row p-5">
                    <div class="col-sm-12">
                        <a>
                            <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_039.png">
                        </a>
                        <p class="fontMS300 text-center text-gris font-24"><br>
                            LAS CUMANANAS, CARGADAS DE RITMO, INGENIO Y SABIDURÍA POPULAR, HAN SIDO DURANTE 
                            GENERACIONES UN VEHÍCULO PARA LA MEMORIA COLECTIVA, LA CRÍTICA SOCIAL Y LA 
                            AFIRMACIÓN DE LA IDENTIDAD DENTRO DE LAS COMUNIDADES AFRODESCENDIENTES.<br>
                        </p>
                    </div>
                </div>

                <div class="row p-5">
                    <div class="col-sm-6">
                        <img width="100%" src="/assets/images/micrositio/micrositio41/NICOMEDES_040.png">
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS300 text-justify font-24">
                            SU REGISTRO NO SOLO BUSCA CONSERVAR 
                            UNA FORMA DE EXPRESIÓN ANCESTRAL, SINO 
                            TAMBIÉN RECONOCER SU VIGENCIA COMO 
                            TESTIMONIO VIVO DE RESISTENCIA, 
                            CREATIVIDAD Y PERTENENCIA. ESTE 
                            RECONOCIMIENTO TAMBIÉN HONRA EL 
                            LEGADO DE NICOMEDES SANTA CRUZ, QUIEN 
                            DEDICÓ SU VIDA A LA RECOPILACIÓN, 
                            DIFUSIÓN Y PUESTA EN VALOR DE LAS 
                            TRADICIONES AFROPERUANAS. SU TRABAJO 
                            PIONERO ABRIÓ CAMINO PARA QUE ESTAS 
                            EXPRESIONES ENCUENTREN HOY UN LUGAR 
                            EN LA HISTORIA CULTURAL DEL PERÚ.<br>
                        </p>
                    </div>
                </div>
                <div class="row p-5">
                    <div class="col-sm-12" style="position: relative;" >
                        <div style="position: relative; overflow: hidden; height: 530px;">
                            <a class="video" href="https://www.youtube.com/embed/V6ZlZnqge-o?si=6AXAcjQj1esroqpi" target="_blank" style="color: black;">
                                <img class="zoomed-img" src="/assets/images/micrositio/micrositio41/NICOMEDES_043.png" alt="Imagen recortada"/>
                            </a>
                        </div>
                        <p class="fontMS100Italic font-12 text-center" style="word-wrap: break-word;">
                            <br>
                            Cumananas de Yapatera con Abelardo Alzamora<br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=V6ZlZnqge-o" target="_blank" style="color: #000000;">https://www.youtube.com/watch?v=V6ZlZnqge-o</a>    
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoMorado">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-60">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24">
                            
                        </p>
                    </div>
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24 text-justify">
                            En una entrevista sostenida con Pablo A. Maríñez, Nicomedes Santa Cruz sostuvo lo siguiente: «el folklore para mí significa parte 
                            de esta lucha por lograr una identidad cultural, porque definitivamente nuestra América tiene en la cultura popular su más alta 
                            representatividad, su verdadera cultura. Y cuando hemos hecho estas disecciones entre cultura popular y culta, lo que estamos 
                            haciendo es marginar las bases, las fuentes de la cultura viva oponiéndolas a las referencias europeas, que incluso en Europa nacen 
                            de las fuentes populares y nosotros no queremos admitir eso. Entonces yo quisiera que alguien aquí —y si fuera yo mismo el que 
                            lo pudiera desarrollar, mejor— hiciera todo un trabajo comparativo intercontinental de lo que en tal época fue culto, de lo que en 
                            tal época fue popular, de lo que, siendo popular en Europa, pasó a ser culto en América». 
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <p class="fontMS300 text-white font-22">
                            Pregunta 1:<br>
                        </p>
                        <p class="fontMS100 text-white font-22">
                            ¿En qué medida la marginación de la 
                            cultura popular frente a las referencias 
                            europeas ha afectado el 
                            reconocimiento y preservación de las 
                            tradiciones autóctonas en América 
                            Latina?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS300 text-white font-22">
                            Pregunta 2:<br>
                        </p>
                        <p class="fontMS100 text-white font-22">
                            Nicomedes Santa Cruz menciona 
                            la importancia de realizar un 
                            estudio comparativo entre lo 
                            popular y lo culto. ¿Cómo podrían 
                            los estudios actuales incorporar 
                            esta perspectiva para enriquecer la 
                            comprensión de las culturas 
                            mestizas de América Latina?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <p class="fontMS300 text-white font-22">
                            Pregunta 3:<br>
                        </p>
                        <p class="fontMS100 text-white font-22">
                            Según Santa Cruz, la cultura popular 
                            tiene una gran representatividad en la 
                            identidad cultural de América. ¿Cómo
                            podemos hacer visible este patrimonio 
                            en la sociedad contemporánea,
                            especialmente frente a la globalización 
                            y la homogeneización cultural?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Aguirre, C. (2013). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Nicomedes Santa Cruz: la 
                            formación de un intelectual público afroperuano. 
                            Histórica. Vol. XXXVII, no. 2, p. 137-168.<br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Campos Dávila, J. (2005). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Abordaje a la producción de 
                            don Nicomedes Santa Cruz Gamarra: ¡Coba abajo que 
                            abajo están los camotes! En García-Bedoya M., C. 
                            (comp.). Memorias de JALLA 2004 Lima : Sextas 
                            Jornadas Andinas de Literatura Latinoamericana. 
                            Lima, 9-13 de agosto del 2004. Tomo I. Lima: JALLA, 
                            Universidad Nacional Mayor de San Marcos, p. 
                            257-268.<br>
                                <!-- Gafas Moradas EIRL.
                                <br><br>
                                Disponible en: 
                                <a style="color: #000000;" href="https://doi.org/10.1590/1982-25532020144547" target="_blank">
                                https://doi.org/10.1590/1982-25532020144547</a>
                                <br> -->
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Storino, N. (2016). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">“De ser como soy, me alegro”: la 
                            negritud de Nicomedes Santa Cruz. D´Palenque: 
                            literatura y afrodescendencia. Vol. I, no. 1, p. 19-25.<br></span>
                                Disponible en: <br>
                                <a style="color: #000000;" href="https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf" target="_blank">
                                https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf</a>
                                <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Ojeda, M. (2016). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;"> Nicomedes Santa Cruz frente al 
                            canon literario peruano: argumentos para su 
                            inclusión. D´Palenque: literatura y afrodescendencia. 
                            Vol. I, no. 1, p. 9-18. 
                                Disponible en: 
                                <a style="color: #000000;" href="https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf" target="_blank">
                                https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf</a>
                                <br>
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Santa Cruz, O. (2015).</span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Mi tío Nicomedes. Lima: 
                            Ediciones Noche de sol. <br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Feldman, H. (2009).  </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Ritmos negros del Perú: 
                            reconstruyendo la herencia musical africana. Lima: 
                            Pontificia Universidad Católica del Perú, Instituto de 
                            Etnomusicología ; Instituto de Estudios Peruanos.
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Maríñez, P. (2000). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Nicomedes Santa Cruz: decimista, 
                            poeta y folklorista afroperuano. Segunda edición. 
                            Lima: Municipalidad Metropolitana de Lima.
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <!-- <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#bb32ac;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                </div> -->

                <div class="row">
                                    
                    <div class="col-sm-3" style="line-height: 500%;">
                        <img class="LineSubsec_Izq" width="100%" 
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6 text-center">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-36" style="color:#bb32ac;">
                            RUTAS DE LECTURA SOBRE <br>LA CULTURA AFROPERUANA
                        </p>
                    </div>
                    <div class="col-sm-3" style="line-height: 500%;">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio14/ET04_MS013_ARG_LINEA1-recortada.png">
                    </div>
                
                    <!-- <p class="fontMS700 text-left font-24" style="color:#bb32ac;">
                        <br><br>
                        RUTAS DE LECTURA SOBRE <br>LA CULTURA AFROPERUANA
                    </p> -->
                    <p class="fontMS300 text-left font-24">
                        <br>
                        <a style="color: #000000;" href="/assets/images/micrositio/micrositio41/listado-autores-cultura-afroperuana.pdf" target="_blank">
                            <img src="/assets/images/micrositio/micrositio41/NICOMEDES_ICONO_000.png" alt="Ícono" style="width: 24px; height: 24px; vertical-align: middle; margin-right: 8px;">
                            Consulta aquí el listado de Publicaciones sobre cultura afroperuana en la Biblioteca Nacional del Perú.
                        </a>
                        <br><br>
                    </p>
                </div>

            </div>
        </div>
    </div>
</div>